export default __webpack_public_path__ + "static/media/header_landing_foto_desktop.5aad36ad.png";